var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFreedesign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    viewBox: "0 0 134.4 129.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-1",
    width: 85.9,
    height: 41,
    x: 28.9,
    y: 28.1,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-2",
    width: 96,
    height: 53,
    x: 21.2,
    y: 52.5,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur1",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("style", null, ".st3{fill:#fff}"))), /*#__PURE__*/React.createElement("path", {
    d: "M84.5 0 19.6 17.5 2.3 82.4l47.6 47.5 64.9-17.5 17.3-64.9z",
    style: {
      fill: "#ea9b37"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m101.4 7.1-67.2-.7L0 64.3l33 58.5 67.2.7 34.2-57.9z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m109.9 31.5-6.4-15.1-16.3-1.9.1-.9 16.8 2 6.7 15.5zM81.7 13.8l-2.8-.3v-.9c.1 0 2.9.3 2.9.3v.9Zm-13.8-1.6-5.5-.7v-.9c.1 0 5.6.7 5.6.7v.9ZM33.5 22.4l-.7-.6L42.9 8.3l16.8 2-.1.9-16.3-1.9zm-15 20.1-.7-.5 3.3-4.5.7.5zm10-13.4-.7-.5 1.7-2.2.7.5zM12.7 73.2 6 57.7l10.1-13.6.8.6-9.8 13.1 6.4 15zm9.9 23-2.2-5.1.8-.4 2.2 5.1zM16 80.9l-1.1-2.6.8-.4 1.1 2.6zm31.1 35.4-16.8-2-6.6-15.5.8-.4 6.4 15.1 16.3 1.9zm24.9 3-5.5-.7v-.9c.1 0 5.6.7 5.6.7v.9Zm-16.6-2-2.8-.3v-.9c.1 0 2.9.3 2.9.3v.9Zm36.1 4.3-16.8-2 .1-.9 16.3 1.9 9.8-13.1.7.5zm13.5-18-.7-.5 1.7-2.2.7.5zm8.3-11.2-.7-.5 3.3-4.5.7.5zm5-6.7-.7-.5 9.7-13.1-6.4-15 .8-.4 6.7 15.5zm.4-33.8-1.1-2.6.8-.4 1.1 2.6zm-5.5-12.8L111 34l.8-.4 2.2 5.1z",
    style: {
      fill: "#fefefe"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M131.9 19 39.7 34.4v-.7l92.2-15.5zM94.3 95.5 2.1 111v-.7l92.2-15.5z",
    className: "st3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m39 48.7-.2-1.4c-.2-1.1-.9-1.6-1.9-1.4s-1.5.9-1.3 2l1.6 9.3c.2 1.1.9 1.6 1.9 1.4s1.5-.9 1.3-2l-.5-3-1.6.3-.4-2.4 4.2-.7.9 5.5c.4 2.5-1 4.4-3.5 4.8s-4.4-1-4.9-3.4L33 48.4c-.4-2.5 1-4.4 3.5-4.8s4.4 1 4.9 3.4l.2 1.4-2.6.4Zm4.2-6.2 7.4-1.3.4 2.4-4.8.8.8 4.8 3.8-.6.4 2.4-3.8.6.9 5 4.8-.8.4 2.4-7.4 1.3-2.9-17.1Zm8.7-1.5 8.3-1.4.4 2.4-2.8.5 2.5 14.7-2.6.4-2.5-14.7-2.8.5L52 41ZM67 38.4l7.2-1.2.4 2.4-4.6.8.9 5 3.7-.6.4 2.4-3.7.6 1.2 7.2-2.6.4L67 38.3Zm18 14.5-3.1-6.7-1.3.2 1.2 7.1-2.6.4-2.9-17.1 4.1-.7c2.5-.4 4.3.9 4.8 3.4l.3 1.9c.3 1.6-.2 2.9-1.2 3.8l3.5 7.3-2.7.5ZM80.2 44l1.3-.2c1-.2 1.5-.9 1.3-1.9l-.3-2c-.2-1-.9-1.5-1.9-1.3l-1.3.2zm6.7-9 7.4-1.3.4 2.4-4.8.8.8 4.8 3.8-.6.4 2.4-3.8.6.9 5 4.8-.8.4 2.4-7.4 1.3-2.9-17.1Zm9.6-1.6 7.4-1.3.4 2.4-4.8.8.8 4.8 3.8-.6.4 2.4-3.8.6.9 5 4.8-.8.4 2.4-7.4 1.3-2.9-17.1Z",
    className: "st3",
    style: {
      filter: "url(#drop-shadow-1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.9 93.3.7 4c-1.9.3-3.4 0-4.4-1.3-.9.7-2 1.2-3.3 1.4-4 .7-7.2-1.5-7.9-5.6l-2.6-15.2c-.7-4 1.6-7.2 5.6-7.9 4.1-.7 7.2 1.5 7.9 5.6l2.6 15.2c.2 1.3.1 2.5-.2 3.6.4.2.9.3 1.6.1Zm-8.2-18.2c-.3-1.7-1.5-2.6-3-2.3s-2.4 1.4-2.1 3.2l2.6 15.2c.3 1.7 1.5 2.6 3 2.3s2.4-1.4 2.1-3.2zM45.9 89l-3.7-21.7 4.2-.7 3.7 21.7c.3 1.6 1.4 2.4 2.8 2.1s2.2-1.3 1.9-2.9l-3.7-21.7 4.1-.7 3.7 21.7c.7 3.9-1.5 7-5.4 7.6-3.9.7-7-1.5-7.7-5.4ZM63 85.8l-2.6-15.2c-.7-4 1.6-7.2 5.6-7.9s7.2 1.5 7.9 5.6l2.6 15.2c.7 4-1.6 7.2-5.6 7.9-4.1.7-7.2-1.5-7.9-5.6m9.3-1.5-2.6-15.2c-.3-1.7-1.5-2.6-3-2.3s-2.4 1.4-2.1 3.2l2.6 15.2c.3 1.7 1.5 2.6 3 2.3s2.4-1.4 2.1-3.2m3.4-22.7 13.4-2.3.7 4-4.6.8 4.1 23.8-4.2.7L81 64.8l-4.6.8zm16.7-2.9 12-2 .7 4-7.7 1.3 1.3 7.7 6.2-1.1.7 4-6.2 1.1 1.4 8.1 7.7-1.3.7 4-12 2z",
    className: "st3",
    style: {
      filter: "url(#drop-shadow-2)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreedesign);
export default __webpack_public_path__ + "static/media/freedesign.3cd10b905f7bcecfc09cac7dd7af0588.svg";
export { ForwardRef as ReactComponent };